<template>
  <v-toolbar
    :light="!isDark"
    :dark="isDark"
    class="global-nav-bar"
    v-if="!isHidden"
    :class="{ transparent: isTransparent }"
  >
    <v-toolbar-title>
      <v-btn flat to="/" class="logo-container">
        <img v-if="!isDark && !isHidden" src="/img/brand/logoDark.svg" alt="">
        <img v-if="isDark && !isHidden" src="/img/brand/logoLight.svg" alt="">
        <img v-if="isHidden" src="/img/brand/logoLight.svg" alt="">
      </v-btn>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <v-toolbar-items
      class="hidden-sm-and-down"
      :class="{'d-none': isNone}"
    >
        <v-btn
        v-for="item in menu"
        :key="item.icon"
        :to="item.url"
        flat
      >{{ item.title }}</v-btn>
    </v-toolbar-items>

    <!-- Mobile Nav -->
    <v-menu
      class="hidden-md-and-up"
      :class="{'d-none': isNone}"
    >
      <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
        <v-list>
          <v-list-tile v-for="item in menu" :key="item.icon">
            <v-list-tile-content>
              <v-list-tile class="w-100" :to="item.url">{{ item.title }}</v-list-tile>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
    </v-menu>
  </v-toolbar>
</template>

<style lang="scss">
.global-nav-bar {
  z-index: 10;
  &.transparent {
    background-color: transparent !important;
    box-shadow: 0 2px 4px -1px rgba(0,0,0,0), 0 4px 5px 0 rgba(0,0,0,0), 0 1px 10px 0 rgba(0,0,0,0);
  }
}

.aboutLink {
  text-decoration: none;
   color: white;
}

.logo-container {
  width: 60px;
  img {
    display: block;
    width: 100%;
  }
}
</style>

<script>

export default {
  name: 'siteNavBar',
  data () {
    return {
      menu: [
        {
          title: 'About',
          url: '/#about'
        },
        {
          title: 'Experiments',
          url: '/experiments'
        },
        {
          title: 'Community',
          url: '/community'
        }
      ]
    }
  },
  computed: {
    isHidden () {
      return this.$store.state.navIsHidden
    },
    isNone () {
      return this.$store.state.navIsNone
    },
    isDark () {
      return this.$store.state.navIsDark
    },
    isTransparent () {
      return this.$store.state.navIsTransparent
    }
  },
  mounted () {
  }
}
</script>
